import { apiBaseUrl } from "./config"
import { getBaseHeader } from "./utils"
import { TITLES } from "./constant/url-segment"
import { genericFetch } from "./common-service"
import { Title } from "../../model"

function getTitlesBaseUrl(): string {
  return `${apiBaseUrl}/${TITLES}`
}

export function findTitles(signal?: AbortSignal): Promise<Title[]> {
  return genericFetch<Title[]>(getTitlesBaseUrl(), {
    headers: getBaseHeader(),
    signal
  })
}



// WEBPACK FOOTER //
// ./src/service/sfp/titles-service.ts